import { createAction } from '@reduxjs/toolkit';
import { PostsQueryQuery } from 'gql/graphql';

export const addNewPost = createAction<NonNullable<PostsQueryQuery['posts']>[number]>('newPosts/addNewPost');
export const markNewPost = createAction<number>('newPosts/markNewPost');
export const removeNewPosts = createAction('newPosts/removeNewPost');
